import { defineRecipe, defineSlotRecipe } from '@chakra-ui/react'

// Newsreader is an accent, not the default voice of the application. It is only
// applied from 2xl (24px) upward, where the serif reads as a deliberate display
// face. Anything smaller stays in TASA Orbiter so it does not look like a
// rendering mistake. See docs/design-system-exceptions.md and CLAUDE.md.
export const HEADING_ACCENT_SIZES = ['2xl', '3xl', '4xl', '5xl', '6xl', '7xl'] as const
export const HEADING_BODY_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'] as const

const accentSizeVariants = Object.fromEntries(
  HEADING_ACCENT_SIZES.map(size => [size, { textStyle: size, fontFamily: 'heading' }])
)
const bodySizeVariants = Object.fromEntries(
  HEADING_BODY_SIZES.map(size => [size, { textStyle: size, fontFamily: 'body' }])
)

export const headingTypographyRecipe = defineRecipe({
  base: {
    // Chakra's built-in heading recipe sets fontFamily: 'heading' in its own base
    // and our config is merged into it, so the body default has to be restated
    // here rather than merely omitted.
    fontFamily: 'body',
    fontWeight: 'medium',
  },
  variants: {
    size: {
      ...bodySizeVariants,
      ...accentSizeVariants,
    },
  },
})

export const drawerTypographyRecipe = defineSlotRecipe({
  slots: [
    'trigger',
    'backdrop',
    'positioner',
    'content',
    'header',
    'body',
    'footer',
    'title',
    'description',
    'closeTrigger',
  ],
  base: {
    title: {
      textStyle: 'featureTitle',
    },
  },
})

export const emptyStateTypographyRecipe = defineSlotRecipe({
  slots: ['root', 'content', 'indicator', 'title', 'description'],
  base: {
    title: {
      textStyle: 'featureTitle',
    },
  },
})
